$(function() {
  
  /*==========================*/
  /* Global Variables */
  /*==========================*/

  var   THE_BODY              = $('body'),
  HEADER                = $('#header'),
  FOOTER                = $('#footer'),
  IS_INDEX              = (THE_BODY.hasClass('template-index')) ? true : false,
  IS_COLLECTION         = (THE_BODY.hasClass('template-collection')) ? true : false,
  IS_COLLECTION_LISTING = ($('#collection-list').length > 0) ? true : false,
  IS_PRODUCT            = (THE_BODY.hasClass('template-product')) ? true : false,
  IS_BLOG               = (THE_BODY.hasClass('template-blog')) ? true : false,
  IS_ARTICLE            = (THE_BODY.hasClass('template-article')) ? true : false,
  IS_SEARCH             = (THE_BODY.hasClass('template-search')) ? true : false,
  IS_CART               = (THE_BODY.hasClass('template-cart')) ? true : false,
  HAS_LOGO              = (HEADER.hasClass('use-logo')) ? true : false,
  BE_WIDE               = (HEADER.hasClass('wide')) ? true : false,
  HAS_CURRENCIES        = (THE_BODY.hasClass('currencies')) ? true : false,
  HAS_TWITTER           = (FOOTER.hasClass('has-twitter')) ? true : false,
  IS_IE                 = /msie/i.test(navigator.userAgent),
  /* PRODUCT_IMAGE_W_TO_H_RATIO = product_image_w_to_h_ratio || 1,
  THREE_PER_ROW_W       = 268,
  FOUR_PER_ROW_W        = 191,
  THREE_PER_ROW_H       = parseInt(THREE_PER_ROW_W/PRODUCT_IMAGE_W_TO_H_RATIO,  10),
  FOUR_PER_ROW_H        = parseInt(FOUR_PER_ROW_W/PRODUCT_IMAGE_W_TO_H_RATIO,   10), */
  IS_MOBILE             = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
        
  /* Multiple currencies */
  /*==========================*/

  if (HAS_CURRENCIES) {
        
    $('#currency-picker-toggle a').click(function() {
      $('#currency-picker-toggle').hide();
      $('#currencies-picker').fadeIn();
      return false;
    });

    $('#currencies-picker select').change(function() {
      $('#currencies-picker').hide();
      $('#currency-picker-toggle').fadeIn();
      return true;
    }).blur(function() {
      $('#currencies-picker').hide();
      $('#currency-picker-toggle').fadeIn();
      return true;
    });

  }
        
  $('.localize').tooltip();
  $('.tip').popover({
    trigger: 'click',
    placement: 'left',
    html: true
  });

  /* Mailchimp forms */
  /*==========================*/
  var mailchimpFormsFunction = (function(el){
    var $mailChimpForm = el;
    var $mailChimpFormResponses = $mailChimpForm.find('.mailchimp-form__responses');

    var mailchimpUrl = 'https://labsupnet.us7.list-manage.com/subscribe/post-json?u=6773aa8ee7ec2577cc6fd0372&amp;id=7a19b160f7';

    $mailChimpForm.ajaxChimp({
      url: mailchimpUrl,
      callback: callbackFunction
    });

    function callbackFunction (resp) {
      $mailChimpFormResponses.find('.response').html(resp.msg).slideDown();
      setTimeout(function() {
        $mailChimpFormResponses.find('.response').slideUp();
      }, 2000);
    }

  });
  mailchimpFormsFunction($('#mailchimp_form_sidebar'));
  mailchimpFormsFunction($('#mailchimp_form_footer'));

  /* Filter menu toggle */
  /*==========================*/
  var filterMenuToggleFunction = (function(){
    var $filterMenu = $('.filter-menu');
    var $filterMenuToggle = $filterMenu.find('.filter-toggle');
    var $filterMenuClear = $filterMenu.find('.filter-clear');
    var $filterMenuContent = $filterMenu.find('.filter-content');
    var $filterCollectionContainer = $filterMenu.find('.collection-container');
    var windowSize = 992;

    $filterMenuToggle.on('click', filterContentToggle)

    function filterContentToggle() {
      $filterMenuContent.toggleClass('closed');
      $filterMenuToggle.toggleClass('closed');
      $filterMenuClear.toggleClass('closed');
    };

    function watchScreenSize() {
      if(!$filterCollectionContainer.hasClass('selected')) {
        if($(window).width() < windowSize) {
          $filterMenuContent.addClass('closed');
          $filterMenuToggle.addClass('closed');
          $filterMenuClear.addClass('closed');
        } else {
          $filterMenuContent.removeClass('closed');
          $filterMenuToggle.removeClass('closed');
          $filterMenuClear.removeClass('closed');
        }        
      }
    };

    $(window).on('resize', watchScreenSize);
    watchScreenSize();

  })();

  /* Header navigatioin menu toggle fix*/
  /*==========================*/
  var HeaderNavigationFix = (function(){
    $(document).on('click','.navbar-toggle',function(e) {
      if( $('.navbar-collapse').hasClass('in') ) {
        $('.navbar-collapse').hide().removeClass('in');
      } else {
        $('.navbar-collapse').show().addClass('in');
      }
    });
  })();

  /* Topbar */
  /*==========================*/
  var topbarFunction = function(){
    $('body').mouseleave(function() {
      $('.topbar').addClass('active');
      $('body').addClass('topbar-active');
    });
    $('.navbar-collapse').mouseenter(function() {
      if($('.topbar').hasClass('active')) {
        $('.topbar').removeClass('active');
        $('body').removeClass('topbar-active');
      }
    });

    $('.navbar').mouseenter(function() {
      $('.row-nav-bar.collapse').addClass('row-down');
    });

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var topbarHeight = $('.topbar').outerHeight();

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
      var st = $(this).scrollTop();
      
      // Make sure they scroll more than delta
      if(Math.abs(lastScrollTop - st) <= delta)
        return;
      
      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > topbarHeight){
        // Scroll Down
        $('.topbar').removeClass('topbar-down').addClass('topbar-up');
        $('body').removeClass('topbar-down').addClass('topbar-up');

        if($('.topbar').hasClass('active')) {
          $('.topbar').removeClass('active');
          $('body').removeClass('topbar-active');
        }
      } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
          $('.topbar').removeClass('topbar-up').addClass('topbar-down');
          $('body').removeClass('topbar-up').addClass('topbar-down');
        }
      }
      
      lastScrollTop = st;
    }
  };

  if ($('body').data('cart-items') != 0) {
    topbarFunction();
  }

  /* Product page */
  /*==========================*/
  var productPageFunction = function(){

    // description toggle
    var toggle = $('.product-page-container--product-info--description--overflow-container--toggle');
    var overflowContainer = $('.product-page-container--product-info--description--overflow-container');

    toggle.on('click', function() {
      if (overflowContainer.hasClass('open')) {
        $('html, body').animate({
          scrollTop: overflowContainer.offset().top - $('.navbar').outerHeight()
        }, 300);
      }

      overflowContainer.toggleClass('open');
    });

    // description tabs open description
    $(document).on('click','.product-description-content .nav-tabs li', function() {
      if(!overflowContainer.hasClass('open')) {
        overflowContainer.addClass('open');
      }
    });

    // toggle notice
    $('.notice .panel-heading').on('click', function() {
      $(this).closest('.notice').toggleClass('open');
    });

  };

  if($('.template-product').length) {
    productPageFunction();
  }

  /* Truncate thumbnail parts */
  /*==========================*/
  var truncateFunction = function(){
    if($(window).width() < 993) {
      $('.title-and-description').truncate({ lines : 3 });
      $('.title-and-description .title').truncate({ lines: 1 });
    } else {
      $('.title-and-description').truncate({ lines : 6 });
      $('.title-and-description .title').truncate({ lines : 2 });
    }
  };
  truncateFunction();

  var truncateUpdateFunction = function(){
    if($(window).width() < 993) {
      $('.title-and-description').truncate('config', { lines : 3 });
      $('.title-and-description .title').truncate('config', { lines : 1 });
    } else {
      $('.title-and-description').truncate('config', { lines : 6 });
      $('.title-and-description .title').truncate('config', { lines : 2 });
    }
  };

  $(window).on('resize', function(){
    truncateUpdateFunction();
  });

});
